module.exports = __webpack_public_path__ + "img/icon-1.05e7be9.png";